import React, { Component } from "react";
import "../initialPage/asidebar.css";
import { Col, Row, Container, Navbar, NavbarBrand } from 'bootstrap-4-react';

class Asidebar extends React.Component{
  constructor(props){
    super(props);
    this.state={

    }
  }

  componentDidMount(){

  }

  render(){
    const { openMenu,module } = this.props.initState;
    return(
      <asidebar className={`main-sidebar ${(openMenu) ? 'hide-main-sidebar' : ''}`}>
        <div className="main-sidebar-content">

          <p className={`mb-2 ${(module==='dashboard') ? 'ws_module_selected' : '' }`}
          onClick={
            (e) => {
              this.initsetState({
                module:'dashboard'
              })
            }
          }
          ><span><img className="sidebar-icon" src={'img/pos2/i-dash-b.svg'}  /></span> Dashboard</p>

          <p className={`mb-2 ${(module==='tienda') ? 'ws_module_selected' : '' }`}
          onClick={
            (e) => {
              this.initsetState({
                module:'tienda'
              })
            }
          }
          ><span><img className="sidebar-icon" src={'img/pos2/i-store-b.svg'}  /></span> Tienda</p>

          <p className={`mb-2 ${(module==='consultorio') ? 'ws_module_selected' : '' }`}
          onClick={
            (e) => {
              this.initsetState({
                module:'consultorio'
              })
            }
          }
          ><span><img className="sidebar-icon" src={'img/pos2/i-consult-b.svg'}  /></span> Consultorio</p>

          <hr />
          {
            /*
          <p className={`mb-2 ${(module==='pos') ? 'ws_module_selected' : '' }`}
          onClick={
            (e) => {
              this.initsetState({
                module:'pos'
              })
            }
          }
          ><span><img className="sidebar-icon" src={'img/pos2/i-pos-b.svg'}  /></span> PoS</p>
          <hr />
          <p className={`mb-2 ${(module==='ventas') ? 'ws_module_selected' : '' }`}
          onClick={
            (e) => {
              this.initsetState({
                module:'ventas'
              })
            }
          }
          ><span><img className="sidebar-icon" src={'img/pos2/i-sell-b.svg'}  /></span> Ventas</p>
          <p className={`mb-2 ${(module==='costos') ? 'ws_module_selected' : '' }`}
          onClick={
            (e) => {
              this.initsetState({
                module:'costos'
              })
            }
          }
          ><span><img className="sidebar-icon" src={'img/pos2/i-cost-b.svg'}  /></span> Costos</p>
          <p className={`mb-2 ${(module==='gastos') ? 'ws_module_selected' : '' }`}
          onClick={
            (e) => {
              this.initsetState({
                module:'gastos'
              })
            }
          }
          ><span><img className="sidebar-icon" src={'img/pos2/i-buys-b.svg'}  /></span> Gastos</p>
          <p className={`mb-2 ${(module==='inventarios') ? 'ws_module_selected' : '' }`}
          onClick={
            (e) => {
              this.initsetState({
                module:'inventarios'
              })
            }
          }
          ><span><img className="sidebar-icon" src={'img/pos2/i-inventory-b.svg'}  /></span> Inventarios</p>
          <hr />
          <p className={`mb-2 ${(module==='empleados') ? 'ws_module_selected' : '' }`}
          onClick={
            (e) => {
              this.initsetState({
                module:'empleados'
              })
            }
          }
          ><span><img className="sidebar-icon" src={'img/pos2/i-employee-b.svg'}  /></span> Empleados</p>
          <p className={`mb-2 ${(module==='descuentos') ? 'ws_module_selected' : '' }`}
          onClick={
            (e) => {
              this.initsetState({
                module:'descuentos'
              })
            }
          }
          ><span><img className="sidebar-icon" src={'img/pos2/i-disscount-b.svg'}  /></span> Descuentos</p>
          <p className={`mb-2 ${(module==='clientes') ? 'ws_module_selected' : '' }`}
          onClick={
            (e) => {
              this.initsetState({
                module:'clientes'
              })
            }
          }
          ><span><img className="sidebar-icon" src={'img/pos2/i-customer-b.svg'}  /></span> Clientes</p>
          <p className={`mb-2 ${(module==='proveedores') ? 'ws_module_selected' : '' }`}
          onClick={
            (e) => {
              this.initsetState({
                module:'proveedores'
              })
            }
          }
          ><span><img className="sidebar-icon" src={'img/pos2/i-provider-b.svg'}  /></span> Proveedores</p>
        */}
          <p className={`mb-2 ${(module==='salir') ? 'ws_module_selected' : '' }`}
          onClick={
            (e) => {
              this.initsetState({
                module:'salir'
              })
            }
          }
          ><span><img className="sidebar-icon" src={'img/pos2/i-exit-b.svg'}  /></span> Salir</p>
        </div>
      </asidebar>
    )
  }

  initsetState(param) {
    this.props.initsetState(param)
    return true
  }

}

export default Asidebar